import { useNavigate, useParams } from "react-router-dom";
import { Drawer } from "@mui/material";
import useRoutes from "@/hooks/useRoutes";
import { CompletedOrder, Order } from "@/types";
import OrderInfoTabs from "./OrderInfoTabs";
import TutorialsSubscriber from "@/components/TutorialsSubscriber";
import { ProductIds } from "@/constants/productIds";

interface Props {
  order: Order | CompletedOrder | null;
}

const OrderDetailsDrawer = ({ order }: Props) => {
  const [_, getUrl] = useRoutes();
  const navigate = useNavigate();
  const { organizationId } = useParams<{ organizationId: string }>();

  const handleClose = () => {
    const url = getUrl("organizations.orders.main", { organizationId: organizationId ?? "" });
    navigate(url as string);
  };

  return (
    <>
      <Drawer open={order !== null} onClose={handleClose}>
        {order ? (
          <OrderInfoTabs order={order as unknown as Order} onClose={handleClose} />
        ) : null}
      </Drawer>
      <TutorialsSubscriber productIds={[ProductIds.ORDER]} />
    </>
  );
};

export default OrderDetailsDrawer;
